module.exports = __webpack_public_path__ + "b1314e56239cde0e49e303581d213772.svg";